import { render } from "./StoreRequisitionApprovalList.vue?vue&type=template&id=39612df6&scoped=true"
import script from "./StoreRequisitionApprovalList.vue?vue&type=script&lang=js"
export * from "./StoreRequisitionApprovalList.vue?vue&type=script&lang=js"

import "./StoreRequisitionApprovalList.vue?vue&type=style&index=0&id=39612df6&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39612df6"]])

export default __exports__